import { Email, Phone, CalendarToday, AddComment } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import React from "react";

import { SafeArgonButton } from "0.Mine/4.Argon/ArgonComponents";

import { ActivityNote } from "../sharedTypes";

interface ViewAllActivitiesDialogProps {
  open: boolean;
  onClose: () => void;
  activities: ActivityNote[];
  leadName: string;
}

const ViewAllActivitiesDialog: React.FC<ViewAllActivitiesDialogProps> = ({
  open,
  onClose,
  activities,
  leadName,
}) => {
  console.log(activities);
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" scroll="paper">
      <DialogTitle
        sx={{
          background: "#494b95",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Storia delle attività per {leadName}</Typography>
        <IconButton edge="end" onClick={onClose} sx={{ color: "#ffffff!important" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {activities.length > 0 ? (
          <List>
            {activities.map((activity) => (
              <ListItem key={activity.id} alignItems="flex-start" sx={{ mb: 1 }}>
                <ListItemIcon sx={{ minWidth: "40px", fontSize: "20px" }}>
                  {activity.type === "email" && <Email color="info" />}
                  {activity.type === "call" && <Phone color="warning" />}
                  {activity.type === "meeting" && <CalendarToday color="success" />}
                  {activity.type === "note" && <AddComment color="secondary" />}
                  {activity.type === "movecard" && <AddComment color="secondary" />}
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Box display="flex" justifyContent="space-between">
                      <Typography
                        variant="subtitle1"
                        sx={{ fontSize: "15px", lineHeight: "20px", fontWeight: "500" }}
                      >
                        {activity.title} - {activity.user_name}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#4f5e93",
                          fontWeight: "500",
                          fontSize: "13px",
                          borderRadius: "80px",
                          padding: "3px 13px",
                        }}
                      >
                        {new Date(activity.date).toLocaleDateString()}
                      </Typography>
                    </Box>
                  }
                  secondary={
                    <Typography
                      variant="body2"
                      color="text.primary"
                      sx={{
                        mt: 1,
                        marginTop: "-4px",
                        marginBottom: "5px",
                        paddingBottom: "12px",
                        borderBottom: "1px solid #e8e8e8",
                        fontSize: "14px",
                        color: "#757575",
                      }}
                    >
                      {activity.description}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="200px">
            <Typography variant="body1" color="text.secondary">
              No activity records found
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <SafeArgonButton variant="contained" onClick={onClose}>
          Chiudi
        </SafeArgonButton>
      </DialogActions>
    </Dialog>
  );
};

export default ViewAllActivitiesDialog;
